import React, { useMemo } from "react";
import { CreatableSelect } from "@atlaskit/select";
import { useSelector } from "react-redux";

export const FLOW_GROUP_NAME_PLACEHOLDER = "Type to create new group or select existing";

const FlowGroupNameSelect = ({ value, onChange, placeholder = FLOW_GROUP_NAME_PLACEHOLDER }) => {
  const flows = useSelector((state) => state.integration.flows || []);

  const groupOptions = useMemo(
    () =>
      [...new Set(flows.map((flow) => (flow?.groupName || "").trim()).filter((groupName) => groupName))]
        .sort((groupNameA, groupNameB) => groupNameA.localeCompare(groupNameB))
        .map((groupName) => ({
          label: groupName,
          value: groupName,
        })),
    [flows],
  );

  const selectedOption = groupOptions.find((option) => option.value === value) || (value ? { label: value, value } : null);

  const handleSelect = (selected, event) => {
    if (event?.action === "clear") {
      onChange("");
      return;
    }

    onChange(selected?.value || "");
  };

  const handleCreate = (newValue) => {
    if (!newValue) {
      return;
    }

    onChange(newValue.substring(0, 70));
  };

  return (
    <div style={{ minWidth: `${FLOW_GROUP_NAME_PLACEHOLDER.length}ch` }}>
      <CreatableSelect
        isClearable
        spacing="compact"
        placeholder={placeholder}
        options={groupOptions}
        value={selectedOption}
        onChange={handleSelect}
        onCreateOption={handleCreate}
      />
    </div>
  );
};

export default FlowGroupNameSelect;
